export default __webpack_public_path__ + "static/media/K_wdt_c_cap_1.2608ff9a.mp3";